import { Routes } from '@angular/router';
import { faGavel } from '@fortawesome/pro-duotone-svg-icons';
import { genericResolver } from '@nittenapps/api';
import { dirtyGuard } from '@nittenapps/common';
import { NavItem } from '@nittenapps/components';

export const LITIGATION_ITEMS: NavItem[] = [
  {
    label: 'Juicios',
    icon: faGavel,
    iconSet: 'duo',
    roles: ['litigation', 'litigation_mngr'], //Actualizar rol
    children: [
      {
        label: 'Juicios',
        icon: faGavel,
        iconSet: 'duo',
        roles: ['litigation', 'litigation_mngr'],
        routerLink: ['litigation', 'litigation'],
      },
    ],
  },
];

export const ROUTES: Routes = [
  {
    path: 'litigation',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Juicios',
      roles: ['litigation', 'litigation_mngr'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./litigation/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./litigation/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.claim?.extNumber || 'Nuevo'}` },
        },
      },
    ],
  },
];
